<template>
  <div class="col-md-12">
    <!-- Tabs mejorados -->
    <ul class="nav nav-tabs nav-tabs-custom" id="vehiculosTab" role="tablist">
      <li class="nav-item">
        <a
          :class="['nav-link', { active: pestanaVehiculos === 'activos' }]"
          id="tab-VehAct"
          href="#"
          role="tab"
          v-show="tieneActivos"
          @click.prevent="seleccionarPestana('activos')"
        >
          <i class="fas fa-truck-moving mr-1"></i>
          <span class="badge badge-success mr-1">{{
            $parent.dataPaginaActivos.total || 0
          }}</span>
          Activos
        </a>
      </li>
      <li class="nav-item">
        <a
          :class="['nav-link', { active: pestanaVehiculos === 'inactivos' }]"
          id="tab-VehInact"
          href="#"
          role="tab"
          v-show="tieneInactivos"
          @click.prevent="seleccionarPestana('inactivos')"
        >
          <i class="fas fa-pause-circle mr-1"></i>
          <span class="badge badge-danger mr-1">{{
            $parent.dataPaginaInactivos.total || 0
          }}</span>
          Inactivos
        </a>
      </li>
    </ul>

    <div class="tab-content" id="vehiculosTabContent">
      <!-- Tab Activos -->
      <div
        :class="[
          'tab-pane',
          'fade',
          { 'active show': pestanaVehiculos === 'activos' },
        ]"
        id="VehAct"
        v-show="tieneActivos && pestanaVehiculos === 'activos'"
        role="tabpanel"
      >
        <div class="p-0">
          <div class="table-responsive">
            <table
              id="activos"
              class="table table-bordered table-striped table-hover table-sm text-nowrap m-0 text-center align-middle"
            >
              <thead class="thead-dark">
                <tr>
                  <th colspan="8">
                    <i class="fas fa-info-circle mr-1"></i>
                    Información del Viaje
                  </th>
                  <th colspan="4">
                    <i class="fas fa-map-marker-alt mr-1"></i>
                    Último Registro GPS
                  </th>
                </tr>
                <tr>
                  <th>Tipo de Viaje</th>
                  <th><i class="fas fa-route mr-1"></i>Viaje</th>
                  <th>
                    <i class="fas fa-file-alt mr-1"></i>Bloque
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.bloqueFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar bloque"
                    />
                  </th>
                  <th>
                    <i class="fas fa-truck mr-1"></i>Vehículo
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.vhFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar vehículo"
                    />
                  </th>
                  <th>
                    <i class="fas fa-trailer mr-1"></i>Remolque
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.remFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar remolque"
                    />
                  </th>
                  <th>
                    <i class="fas fa-user mr-1"></i>Conductor
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.condFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar conductor"
                    />
                  </th>
                  <th>
                    <i class="fas fa-building mr-1"></i>Transportadora
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.transFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar transportadora"
                    />
                  </th>
                  <th><i class="fas fa-route mr-1"></i>Ruta</th>
                  <th><i class="fas fa-map-marker mr-1"></i>Último Registro</th>
                  <th><i class="fas fa-globe mr-1"></i>Latitud</th>
                  <th><i class="fas fa-globe mr-1"></i>Longitud</th>
                  <th><i class="fas fa-map mr-1"></i>Dirección</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in $parent.dataPaginaActivos?.data || []"
                  :key="item.id"
                  @click="ubicacionFila(item)"
                  style="cursor: pointer"
                >
                  <td>
                    {{
                      item.tep_viaje
                        ? "Tep Viaje"
                        : item.tep_turno
                        ? "Tep Turno"
                        : item.tif_turno
                        ? "Tif Turno"
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.tep_viaje
                        ? item.tep_viaje.id
                        : item.tep_turno
                        ? item.tep_turno.id
                        : item.tif_turno
                        ? item.tif_turno.id
                        : ""
                    }}
                  </td>
                  <td
                    v-if="
                      (item.tep_viaje &&
                        item.tep_viaje.solicitudes &&
                        item.tep_viaje.solicitudes.bloque) ||
                        (item.tif_turno && item.tif_turno.bloque) ||
                        (item.tep_turno &&
                          item.tep_turno.postulacion &&
                          item.tep_turno.postulacion.tep_nominacion &&
                          item.tep_turno.postulacion.tep_nominacion.bloque)
                    "
                  >
                    {{
                      item.tep_viaje &&
                      item.tep_viaje.solicitudes &&
                      item.tep_viaje.solicitudes.bloque
                        ? item.tep_viaje.solicitudes.bloque.nombre
                        : item.tif_turno
                        ? item.tif_turno.bloque.nombre
                        : item.tep_turno &&
                          item.tep_turno.postulacion &&
                          item.tep_turno.postulacion.tep_nominacion &&
                          item.tep_turno.postulacion.tep_nominacion.bloque
                        ? item.tep_turno.postulacion.tep_nominacion.bloque
                            .nombre
                        : ""
                    }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Bloque</span>
                  </td>
                  <td>
                    {{ item ? item.placa : "" }}
                  </td>
                  <td v-if="item.tif_turno && item.tif_turno.remolque_id">
                    {{ item.tif_turno.remolque.placa }}
                  </td>
                  <td v-else>
                    <span class="badge badge-danger">Sin Remolque</span>
                  </td>
                  <td>
                    {{
                      item.tep_viaje && item.tep_viaje.conductor_id
                        ? item.tep_viaje.conductor.nombres +
                          " " +
                          item.tep_viaje.conductor.apellidos
                        : item.tep_turno && item.tep_turno.conductor_id
                        ? item.tep_turno.conductor.nombres +
                          " " +
                          item.tep_turno.conductor.apellidos
                        : item.tif_turno && item.tif_turno.conductor_id
                        ? item.tif_turno.conductor.nombres +
                          " " +
                          item.tif_turno.conductor.apellidos
                        : "Sin Conductor"
                    }}
                  </td>
                  <td>
                    {{
                      item.tep_viaje && item.tep_viaje.transportadora_id
                        ? item.tep_viaje.transportadora.razon_social
                        : item.tep_turno && item.tep_turno.empresa_id
                        ? item.tep_turno.empresa.razon_social
                        : item.tif_turno && item.tif_turno.empresa_id
                        ? item.tif_turno.empresa.razon_social
                        : "Sin Empresa"
                    }}
                  </td>
                  <td
                    v-if="
                      (item.tep_viaje && item.tep_viaje.ruta_id) ||
                        (item.tif_turno && item.tif_turno.tif_ruta_id)
                    "
                  >
                    {{
                      item.tep_viaje && item.tep_viaje.ruta_id
                        ? item.tep_viaje.ruta.nombre
                        : item.tif_turno && item.tif_turno.tif_ruta_id
                        ? item.tif_turno.ruta.nombre
                        : ""
                    }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Ruta</span>
                  </td>
                  <td v-if="item.ultimo_registro">
                    {{ item.ultimo_registro.fecha_hora_ultimo_reporte }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.dblLatitud }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.dblLongitud }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.strDireccion }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer mejorado -->
          <div class="card-footer p-2">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div v-if="$parent.dataPaginaActivos.total" class="text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  Mostrando del
                  <strong>{{ $parent.dataPaginaActivos.from }}</strong> al
                  <strong>{{ $parent.dataPaginaActivos.to }}</strong> de un
                  total:
                  <strong>{{ $parent.dataPaginaActivos.total }}</strong>
                  Registros
                </div>
                <div v-else>
                  <span class="badge badge-danger">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    No hay registros para mostrar
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <pagination
                  :data="$parent.dataPaginaActivos"
                  class="float-right m-0"
                  @pagination-change-page="$parent.showCarros"
                  :limit="10"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Inactivos -->
      <div
        :class="[
          'tab-pane',
          'fade',
          { 'active show': pestanaVehiculos === 'inactivos' },
        ]"
        id="VehInact"
        v-show="tieneInactivos && pestanaVehiculos === 'inactivos'"
        role="tabpanel"
      >
        <div class="p-0">
          <div class="table-responsive">
            <table
              id="inactivos"
              class="table table-bordered table-striped table-hover table-sm text-nowrap m-0 text-center align-middle"
            >
              <thead class="thead-dark">
                <tr>
                  <th colspan="3">
                    <i class="fas fa-info-circle mr-1"></i>
                    Información del Vehículo
                  </th>
                  <th colspan="4">
                    <i class="fas fa-map-marker-alt mr-1"></i>
                    Último Registro GPS
                  </th>
                </tr>
                <tr>
                  <th>
                    <i class="fas fa-truck mr-1"></i>Vehículo
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filterInactivos.vhFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar vehículo"
                    />
                  </th>
                  <th>
                    <i class="fas fa-trailer mr-1"></i>Remolque
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filterInactivos.remFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar remolque"
                    />
                  </th>
                  <th>
                    <i class="fas fa-building mr-1"></i>Transportadora
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filterInactivos.transFilter"
                      @keyup.enter="$parent.showCarros()"
                      placeholder="Filtrar transportadora"
                    />
                  </th>
                  <th><i class="fas fa-map-marker mr-1"></i>Último Registro</th>
                  <th><i class="fas fa-globe mr-1"></i>Latitud</th>
                  <th><i class="fas fa-globe mr-1"></i>Longitud</th>
                  <th><i class="fas fa-map mr-1"></i>Dirección</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in $parent.dataPaginaInactivos?.data || []"
                  :key="item.id"
                  @click="ubicacionFila(item)"
                  style="cursor: pointer"
                >
                  <td>
                    {{ item ? item.placa : "" }}
                  </td>
                  <td v-if="item.tif_turno && item.tif_turno.remolque_id">
                    {{ item.tif_turno.remolque.placa }}
                  </td>
                  <td v-else>
                    <span class="badge badge-danger">Sin Remolque</span>
                  </td>
                  <td v-if="item.empresa_id">
                    {{ item.empresa.razon_social }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Empresa</span>
                  </td>
                  <td v-if="item.ultimo_registro">
                    {{ item.ultimo_registro.fecha_hora_ultimo_reporte }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.dblLatitud }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.dblLongitud }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                  <td v-if="item.ultimo_registro && item.ultimo_registro.gps">
                    {{ item.ultimo_registro.gps.strDireccion }}
                  </td>
                  <td v-else>
                    <span class="badge badge-warning">Sin Último Registro</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer mejorado -->
          <div class="card-footer p-2">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  v-if="$parent.dataPaginaInactivos.total"
                  class="text-muted"
                >
                  <i class="fas fa-info-circle mr-1"></i>
                  Mostrando del
                  <strong>{{ $parent.dataPaginaInactivos.from }}</strong> al
                  <strong>{{ $parent.dataPaginaInactivos.to }}</strong> de un
                  total:
                  <strong>{{ $parent.dataPaginaInactivos.total }}</strong>
                  Registros
                </div>
                <div v-else>
                  <span class="badge badge-danger">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    No hay registros para mostrar
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <pagination
                  :data="$parent.dataPaginaInactivos"
                  class="float-right m-0"
                  @pagination-change-page="$parent.showCarros"
                  :limit="10"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from "laravel-vue-pagination";

export default {
  name: "MapasListVehiculos",
  components: {
    pagination,
  },
  data() {
    return {
      /** Filtros columnas tabla Activos (viajes/turnos). */
      filtros: {
        bloqueFilter: "",
        vhFilter: "",
        remFilter: "",
        condFilter: "",
        transFilter: "",
      },
      /** Filtros columnas tabla Inactivos (independientes de `filtros`). */
      filterInactivos: {
        vhFilter: "",
        remFilter: "",
        transFilter: "",
      },
      /** Pestaña visible: evita conflicto entre Bootstrap tabs y clases `active` fijas. */
      pestanaVehiculos: "activos",
    };
  },

  computed: {
    filasActivos() {
      const p = this.$parent.dataPaginaActivos;
      return Array.isArray(p?.data) ? p.data : [];
    },
    filasInactivos() {
      const p = this.$parent.dataPaginaInactivos;
      return Array.isArray(p?.data) ? p.data : [];
    },
    tieneActivos() {
      const p = this.$parent.dataPaginaActivos || {};
      const n = Number(p.total);
      if (this.filasActivos.length > 0 || (Number.isFinite(n) && n > 0)) {
        return true;
      }
      const c = this.$parent.conteoGeneral || {};
      const suma =
        (Number(c.tep_viajes) || 0) +
        (Number(c.tif_turnos) || 0) +
        (Number(c.tep_turnos) || 0);
      return suma > 0;
    },
    tieneInactivos() {
      const p = this.$parent.dataPaginaInactivos || {};
      const n = Number(p.total);
      const conteoI = Number(this.$parent.conteoGeneral?.inactivos);
      return (
        this.filasInactivos.length > 0 ||
        (Number.isFinite(n) && n > 0) ||
        (Number.isFinite(conteoI) && conteoI > 0)
      );
    },
    firmaDatosVehiculos() {
      const c = this.$parent.conteoGeneral || {};
      return [
        this.filasActivos.length,
        this.filasInactivos.length,
        this.$parent.dataPaginaActivos?.total,
        this.$parent.dataPaginaInactivos?.total,
        c.tep_viajes,
        c.tif_turnos,
        c.tep_turnos,
        c.inactivos,
      ].join("|");
    },
  },

  watch: {
    firmaDatosVehiculos() {
      this.ajustarPestanaPorDatos();
    },
  },

  mounted() {
    this.ajustarPestanaPorDatos();
  },

  methods: {
    seleccionarPestana(tab) {
      if (tab === "activos" && !this.tieneActivos) return;
      if (tab === "inactivos" && !this.tieneInactivos) return;
      this.pestanaVehiculos = tab;
    },
    ajustarPestanaPorDatos() {
      const a = this.tieneActivos;
      const i = this.tieneInactivos;
      if (!a && !i) return;
      if (!a && i) {
        this.pestanaVehiculos = "inactivos";
        return;
      }
      if (a && !i) {
        this.pestanaVehiculos = "activos";
        return;
      }
      if (this.pestanaVehiculos === "inactivos" && !i) {
        this.pestanaVehiculos = "activos";
      } else if (this.pestanaVehiculos === "activos" && !a) {
        this.pestanaVehiculos = "inactivos";
      }
    },

    ubicacionFila(item) {
      const gps = item?.ultimo_registro?.gps;

      if (!gps) {
        this.$parent.center.lat = 4.651371;
        this.$parent.center.lng = -74.071509;
        this.$parent.zoom = 6;

        return;
      }

      const lat = Number(gps.dblLatitud);
      const lng = Number(gps.dblLongitud);

      if (isNaN(lat) || isNaN(lng)) {
        this.$parent.center.lat = 4.651371;
        this.$parent.center.lng = -74.071509;
        this.$parent.zoom = 6;

        return;
      }

      this.$parent.center = {
        lat,
        lng,
      };

      this.$parent.zoom = 17;
    },
  },
};
</script>
